import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { Mechanism } from './components/Mechanism';
import { Bundle } from './components/Bundle';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { Faq } from './components/Faq';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2wjqkvgwckmre">
      <main data-id="element-1" data-mp="28ufm24yk52fw">
        <Hero data-id="element-2" data-mp="28tw4wqgqei2x" />
        <Problem data-id="element-3" data-mp="28te0v7ntuzkg" />
        <WhyFailed data-id="element-4" data-mp="28suu8n3mnxlq" />
        <Mechanism data-id="element-5" data-mp="28sbbx5a2f776" />
        <Bundle data-id="element-6" data-mp="23vchsmqej08z" />
        <Audience data-id="element-7" data-mp="23vupqgmff2wq" />
        <HowItWorks data-id="element-8" data-mp="23u9v6r043jyv" />
        <Proof data-id="element-9" data-mp="23ut97wmn5o7m" />
        <Faq data-id="element-10" data-mp="23t8gmcjw0fce" />
        <Offer data-id="element-11" data-mp="3ijxq4swlw4ky" />
      </main>
      <Footer data-id="element-12" data-mp="3ikr0s4yore8d" />
      <StickyCta data-id="element-13" data-mp="3iiwasc8k4vxf" />
    </div>;
}